/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import BottomCurve from '../../../components/BottomCurve';
import HeroButton from '../../../components/HeroButton';
import PageHeading from '../../../components/PageHeading';
import SqzText from '../../../components/SqzText';
import {
  MembershipService,
  PHASES,
  dayjsDateParserUtiliy,
} from '../../../utils/common';
import reCaptchaV3Plugin from '../../../utils/third-party-plugins/recaptcha-v3';
import {
  fetchMembershipDetails,
  setSelectedMembershipType,
} from '../../Membership/actions';
import makeSelectMembership from '../../Membership/selectors';
import { makeSelectUser } from '../../User/selectors';
import makeSelectAppointment from '../selectors';
import { setSelectedLocation } from '../../Appointment/actions';
import { updateUser } from '../../User/actions';

class FranchisePhase3 extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.checkForVowel = this.checkForVowel.bind(this);
    this.renderSubheading = this.renderSubheading.bind(this);
    this.showSpotsAvailable = this.showSpotsAvailable.bind(this);
  }

  showSpotsAvailable() {
    const { locationServices } = this.props.appointmentData;
    const { founding_membership_available_spots } = locationServices;
    return founding_membership_available_spots > 0
      ? `ONLY ${founding_membership_available_spots} SPOTS AVAILABLE!`
      : 'ONLY A FEW SPOTS AVAILABLE!';
  }

  renderSubheading(urlName, launchDate, timeZone) {
    let subHeadingText = '';
    switch (urlName) {
      case 'scottsdale':
        subHeadingText = 'OPENING FALL 2022';
        break;
      case 'brentwood':
        subHeadingText = 'OPENING FALL 2022';
        break;
      case 'rogers':
        subHeadingText = this.showSpotsAvailable();
        break;
      default:
        subHeadingText = `OPENING ${dayjsDateParserUtiliy(
          launchDate,
          timeZone,
          'MMMM YYYY',
        )}`;
        break;
    }
    return subHeadingText;
  }

  componentDidMount() {
    const { fetchLocationServices, locationServices } = this.props;
    reCaptchaV3Plugin('phase3_page');
    const authToken = localStorage.getItem('userToken');
    if (authToken) {
      this.props.fetchMembershipDetails();
    }
    for (let i = 0; i < locationServices.services.length; i += 1) {
      const service = locationServices.services[i];
      if (service.member_price === service.discounted_subscription_price) {
        fetchLocationServices(locationServices.id, false);
        break;
      }
    }
  }

  handleFoundingMembership(service, action) {
    const foundingMembership = MembershipService(service);
    if (action) {
      const { discounted_subscription_price, subscription_price } = service;
      const foundingMembershipDiscount =
        Number(subscription_price) - Number(discounted_subscription_price);
      if (foundingMembershipDiscount > 0) {
        localStorage.setItem(
          'foundingMembershipDiscount',
          foundingMembershipDiscount,
        );
      }
      this.props.setSelectedMembershipType({
        ...foundingMembership,
        action,
      });
      this.props.history.push('/membership/confirm?founding_membership=true');
    }
  }

  renderCardsDesktop(locationServices) {
    const { services } = locationServices;
    const { membershipDetails } = this.props.membershipData;
    const isFoundingMembership =
      membershipDetails &&
      membershipDetails.entity_status_id === 4 &&
      membershipDetails.campaign_id;

    return (
      <div className="priceSection">
        {services.map(service => (
          <div key={services.id} className="price-list">
            <h1
              className="header-font own-header ucase mb0"
              title={service.title}
            >
              {service.title}
            </h1>
            <h4 className="member">membership</h4>
            <h4 className="price">
              <span className="price-strike">${service.member_price}</span>
              <span> ${service.discounted_subscription_price}</span>
            </h4>
            <span className="price-mth">
              One {service.duration}-min massage
              <span className="memberPrice">
                {' '}
                (${service.non_member_price} value) per month
              </span>
            </span>

            {!isFoundingMembership ? (
              <div>
                <button
                  onClick={() =>
                    this.handleFoundingMembership(service, 'create')
                  }
                  className="btn btn--secondary home__btn giftSingleSelectBtn"
                >
                  RESERVE NOW
                </button>
                <div style={{ fontSize: '1.2rem', marginTop: '1.5rem' }}>
                  plus each massage includes your choice of deep tissue, heat
                  therapy, aromatherapy and percussion therapy at no extra cost.
                </div>
              </div>
            ) : isFoundingMembership &&
            membershipDetails.name === service.title ? (
              <div>
                <button className="btn btn--secondary home__btn giftSingleSelectBtn">
                  {"YOU'RE"} IN!
                </button>
                <div style={{ fontSize: '1.2rem', marginTop: '1.5rem' }}>
                  plus each massage includes your choice of deep tissue, heat
                  therapy, aromatherapy and percussion therapy at no extra cost.
                </div>
              </div>
            ) : (
              <div>
                <button
                  className="btn btn--secondary home__btn giftSingleSelectBtn"
                  disabled
                >
                  RESERVE NOW
                </button>
                <div style={{ fontSize: '1.2rem', marginTop: '1.5rem' }}>
                  plus each massage includes your choice of deep tissue, heat
                  therapy, aromatherapy and percussion therapy at no extra cost.
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  checkForVowel(locationName) {
    if (!locationName) {
      return '';
    }
    const firstLetter = locationName.charAt(0).toLowerCase();
    if (
      firstLetter === 'a' ||
      firstLetter === 'e' ||
      firstLetter === 'i' ||
      firstLetter === 'o' ||
      firstLetter === 'u'
    ) {
      return `AN ${locationName}`;
    }
    return `A ${locationName}`;
  }

  render() {
    const { locationServices } = this.props;
    const locationText = !PHASES.includes(locationServices.launch_status)
      ? `Massage Therapy Near By | ${locationServices.city} | Squeeze Massage`
      : `Become ${this.checkForVowel(locationServices.name)} Founding Member!`;
    return (
      <Fragment>
        <section className="price-container">
          <PageHeading urlName={locationServices.url_name}>
            {locationText}
          </PageHeading>
          <div className="price-section">
            <SqzText addClass="smallFontHowItWork phone-only hiwHeader">
              {locationText}
            </SqzText>
            <div className="locTitle">
              <h4 className="locSubTitle">{this.showSpotsAvailable()}</h4>
              <h4 className="mt0  ">
                Up to 40% off massages <u>FOR LIFE</u> <br />
                You won’t be charged until we open our books. <br />
              </h4>
            </div>
            <div
              className="NotifyTherapistModal"
              style={{ textAlign: 'center', background: 'none', padding: 0 }}
            >
              {this.renderCardsDesktop(locationServices)}
            </div>
          </div>
          <HeroButton foundingMembership />
          <BottomCurve />
        </section>
      </Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
  membershipData: makeSelectMembership(),
  user: makeSelectUser(),
});

FranchisePhase3.propTypes = {
  appointmentData: PropTypes.object,
  locationServices: PropTypes.object,
  history: PropTypes.object,
  fetchLocationServices: PropTypes.func,
  membershipData: PropTypes.object,
  fetchMembershipDetails: PropTypes.func,
  setSelectedMembershipType: PropTypes.func,
};

const withConnect = connect(
  mapStateToProps,
  {
    updateUser,
    setSelectedLocation,
    setSelectedMembershipType,
    fetchMembershipDetails,
  },
);

export default compose(
  withRouter,
  withConnect,
)(FranchisePhase3);
